<template>
  <transition name="office" appear>
    <div class="office office-overlay" @click.self="$emit('close')">
      <div class="office-header">

      </div>
      <div class="office-window" @click.self="$emit('close')">
        <div class="office-content">
          <div class="office-left" @click="clickLeft">
          </div>
          <div class="office-right" @click="clickRight">
          </div>
          <div class="office-button" @click="$emit('close')">
            <img src="@/assets/estate_icon/pc/close.png">
          </div>
          <div class="office-image" @click="$emit('close')">
            <img :src="require('../assets/company/banner-'+ message + '-min.png')">
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['message'],
  methods: {
    clickLeft () {
      this.message = this.message + 1
      if (this.message > 4) this.message = 1
    },
    clickRight () {
      this.message = this.message - 1
      if (this.message < 1) this.message = 4
    }
  }
}
</script>

<style lang="scss" scoped>

.office {

  &.office-overlay {
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: rgba(0, 0, 0, 0);
    border-radius: 4px;
    height: 100%;
    overflow: hidden;
  }

  &-content {
    position: relative;
    top: -10vh;
    padding: 0;
    height: 70vh;
    width:100%;
  }

  &-header {
    padding: 0;
    text-align: right;
    position: relative;
    top: 0px;
    width: 100%;
    height: 0vh;
    color: #fff;
    background: rgba(0, 0, 0, 0);

    @media (max-width: 550px) {
      height: 50px;
    }
  }
  &-button{
    position: relative;
    text-align: right;
    top: 40px;
    right: 10px;
    color: #3B3B3B;
    cursor: pointer;
    img{
      width: 30px;
    }
  }
  &-image{
    height: 70vh;
    text-align: center;
    img{
      height: 100%;
      cursor: pointer;
    }
    //@media (max-width: 550px){
      //height: auto;
      //width: 90vw;
      //img{
        //height: auto;
        //width: 100%;
      //}
    //}
  }
  &-left{
    position: absolute;
    text-align: right;
    top: 62%;
    right: 1vw;
    width: 0;
    height: 0;
    border-left: 20px solid white;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    color: #3B3B3B;
    cursor: pointer;
  }
  &-right{
    position: relative;
    text-align: left;
    top: 62%;
    left: 1vw;
    width: 0;
    height: 0;
    border-right: 20px solid white;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    color: #3B3B3B;
    cursor: pointer;
  }
}

// オーバーレイのトランジション
.office-enter-active, .office-leave-active {
  transition: opacity 0.4s;

  // オーバーレイに包含されているモーダルウィンドウのトランジション
  .office-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
.office-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.office-enter, .office-leave-to {
  opacity: 0;

  .office-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
